import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { Table } from '../../Table/Table.es.js';

const AdvancedTableColumnHeader = ({ header })=>{
    const sortingEnabled = header.column.getCanSort();
    const isSorted = typeof header.column.getIsSorted() === 'string';
    const isSortedDesc = header.column.getIsSorted() === 'desc';
    const sortIcon = useMemo(()=>{
        if (isSorted) {
            return isSortedDesc ? 'ArrowSmDownOutline' : 'ArrowSmUpSolid';
        }
        return 'SwitchVerticalSolid';
    }, [
        isSorted,
        isSortedDesc
    ]);
    return jsxs(Table.Head.Cell, {
        className: classNames(header.column.columnDef.meta?.className, {
            'sort-enabled': sortingEnabled
        }),
        colSpan: header.colSpan,
        onClick: header.column.getToggleSortingHandler(),
        style: {
            width: header.getSize()
        },
        children: [
            !header.isPlaceholder && flexRender(header.column.columnDef.header, header.getContext()),
            sortingEnabled && jsx(Icon, {
                name: sortIcon,
                size: 20
            })
        ]
    });
};

export { AdvancedTableColumnHeader };
//# sourceMappingURL=AdvancedTableColumnHeader.es.js.map
